import React from "react";
import SEO from "../../SEO";
import { useCanonicalUrl } from "../../useCanonicalUrl";

const AboutTrustDoc = () => {
  const canonical = useCanonicalUrl();
  return (
    <>
      <SEO
        title="About Trust Doc"
        description="Learn about Trust Doc, our mission, and healthcare services."
         canonical={canonical}
      />

      <div className="about-page">
        {/* Header Section */}
        <header className="about-header">
          <h1>About TrustDoc</h1>
          <p>
            Building trust in healthcare through transparency, convenience, and
            innovation.
          </p>
        </header>

        {/* Content Section */}
        <section className="about-content">
          <p>
            <strong>Trust-Doc.com</strong> is a UAE-based digital health
            platform built on one principle: <strong>trust in care</strong>. We
            make it easy for patients to find and book verified doctors while
            giving clinics a transparent, pay-per-appointment model that drives
            new patient flow without high marketing costs.
          </p>

          <p>
            With just a few clicks, patients can search by specialty, location
            and insurance coverage, view detailed doctor profiles, and book
            appointments instantly. After attending, they even receive a small
            reward — a first in the region — to encourage loyalty and reduce
            no-shows.
          </p>

          <p>
            For clinics and hospitals, Trust-Doc is a zero-risk growth channel:
            you only pay a small fee per completed appointment.{" "}
            <strong>No setup fees. No hidden costs.</strong> Just more patients
            and happier schedules.
          </p>
        </section>

        {/* Style Section */}
        <style>{`
        .about-page {
          min-height: 100vh;
          background: linear-gradient(to bottom right, #f0f9ff, #ffffff, #e0f2fe);
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .about-header {
          width: 100%;
          background-color: #0369a1; /* sky-700 */
          color: white;
          text-align: center;
          padding: 1rem;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }
        .about-header h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          letter-spacing: 1px;
        }
        .about-header p {
          max-width: 700px;
          margin: 0 auto;
          font-size: 1.2rem;
          font-weight: 300;
          opacity: 0.9;
        }
        .about-content {
          max-width: 900px;
          background: white;
          margin: 3rem 1rem 5rem;
          padding: 3rem 3.5rem;
          border-radius: 1.2rem;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          border: 1px solid #f3f4f6; /* subtle border */
        }
        .about-content p {
          color: #374151; /* gray-700 */
          font-size: 1.1rem;
          line-height: 1.75rem;
          margin-bottom: 1.5rem;
        }
        .about-content strong {
          color: #0369a1; /* highlight with blue */
        }
      `}</style>
      </div>
    </>
  );
};

export default AboutTrustDoc;
